module.exports = __webpack_public_path__ + "assets/f3d52146587bf9fbfd67f694399247df.png";